export default __webpack_public_path__ + "d6696bb44c2c79a2ef0d817dcb3b5326.svg";